<template>
	<div>
		Waiting
	</div>
</template>
<script setup>
import {onMounted} from "vue";
import OAuthService from "@/utilities/system/services/OAuthService";

onMounted(async ()=> {
  const oAuthService = OAuthService.getDefaultInstance();
  const oAuthUser = await oAuthService.loginSilent();
  console.log("refresh resp on silent callback page", oAuthUser)
  if(!oAuthUser) return null
})

</script>
